<!--
  --
  -- 免責補償選択シート
  --
  -->
<template>
  <c-base-sheet>
    <!-- ラベル -->
    <template #caption>{{caption}}</template>

    <!-- 説明 -->
    <template #description>
      <span v-html="insurance.desc"/>
    </template>

    <!-- コンテンツ -->
    <template>
      <v-radio-group
        class="c-options-insurance"
        v-model="insurance.value"
      >
        <c-insurance-item
          v-for="item in insurance.items"
          :key="item.id"
          :item="item"
        />
      </v-radio-group>
    </template>

  </c-base-sheet>
</template>

<style lang="scss">
.c-options-insurance {
  margin-top: 0;

  .v-radio {
    align-items: flex-start;
  }

  .c-options-insurance-item {
    margin-top: 3px;

    .text-body-2 {
      margin-top: 3px;
    }
  }
}
</style>

<script>
import CBaseSheet from '../CBaseSheet'
import CInsuranceItem from './CInsuranceItem'

export default {
  name: 'CInsuranceSheet',
  components: {
    CBaseSheet,
    CInsuranceItem
  },

  props: {
    caption: {
      type: String
    },
    insurance: {
      type: Object,
      required: true
    }
  }
}
</script>
